import React from 'react'
import { InvoiceService } from '@/services/invoice.service'
import { CartItem } from '@/types/pos';

export const useInvoiceItems = () => {
    const [items, setItems] = React.useState<CartItem[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | null>(null);

    const fetchInvoiceItems = React.useCallback(async (invoiceId: string) => {
        setLoading(true);
        setError(null);
        try {
            const fetchedItems = await InvoiceService.getInvoiceItems(invoiceId);
            setItems(fetchedItems);
            return fetchedItems;
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        items,
        loading,
        error,
        fetchInvoiceItems,
    };
}